import { render, staticRenderFns } from "./_Instruction.vue?vue&type=template&id=212faa80&"
import script from "./_Instruction.vue?vue&type=script&lang=js&"
export * from "./_Instruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports